import { userResource } from '@/api/user';
import { addFlowNode, editFlowNode, flowNodeDetail } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      cc2: [],
      dataFrom: {
        flowId: this.$route.params.id,
        userId: undefined,
        goBack: 1
      },
      operatorList: [],
      CCList: [],
      customerId: '',
      auditTypeList: [{
        value: 0,
        name: '系统管理员'
      }, {
        value: 1,
        name: '客户管理员'
      }],
      mark: ''
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('节点')
        }],
        auditType: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('操作类型')
        }],
        userId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('操作人')
        }],
        isSms: [{
          required: true,
          message: this.$t('请选择') + this.$t('是否通知短信'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    init(data, id, mark) {
      console.log(data, id, mark);
      this.mark = mark;
      this.customerId = id;
      if (data) {
        flowNodeDetail({
          flowNodeId: data.flowNodeId
        }).then(res => {
          console.log(res);
          this.dataFrom = res;
          this.dataFrom.flowNodeId = res.id;
          this.cc2 = res.cc;
          if (res.auditType == 0 || res.auditType == 1) {
            let type = this.dataFrom.auditType == 0 ? 0 : 1;
            userResource({
              type: type
            }).then(res => {
              this.operatorList = res;
            });
          }
          if (res.ccType == 0 || res.ccType == 1) {
            let type = this.dataFrom.ccType == 0 ? 0 : 1;
            userResource({
              type: type
            }).then(res => {
              console.log(res);
              this.CCList = res;
            });
          }
        });
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          if (this.cc2.length != 0) {
            this.dataFrom.cc = this.cc2.join(',');
          } else {
            this.dataFrom.cc = '';
          }
          let fun = this.dataFrom.flowNodeId ? editFlowNode : addFlowNode;
          fun(this.dataFrom).then(() => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('cancel');
            this.$emit('ok');
          });
        }
      });
    },
    getDataFun() {
      let type = this.dataFrom.auditType == 0 ? 0 : 1;
      //   this.dataFrom.userId=undefined;
      //   console.log(customerId,2221);
      userResource({
        type: type
      }).then(res => {
        console.log(res, 22222);
        this.operatorList = res;
      });
    },
    getDataFun2() {
      let type = this.dataFrom.ccType == 0 ? 0 : 1;
      //   let customerId=this.dataFrom.ccType==0?0:this.customerId;
      this.cc2 = [];
      userResource({
        type: type
      }).then(res => {
        console.log(res);
        this.CCList = res;
      });
    }
  }
};